import React, { memo, useMemo, useEffect, useState } from 'react';
import classes from './storeSchedule.css';
import CloseIcon from '../../../venia-static/icons/closeicon.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { reformatSchedule } from './utils';
import getDirectionGoogleMap from '@magento/peregrine/lib/util/getDirectionGoogleMap';
import { useStoreSwitcher } from '@magento/peregrine/lib/talons/Header/useStoreSwitcher';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { useHistory } from "react-router-dom";
var StoreSchedule = _ref => {
  var {
    setSchedule,
    schedule
  } = _ref;
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var [{
    currentStore
  }] = useAppContext();
  var {
    formatMessage
  } = useIntl();
  var history = useHistory();
  var [mount, setMount] = useState(false);
  var timeSchedule = useMemo(() => {
    if (currentStore) {
      return reformatSchedule(currentStore.schedule);
    }
    return [];
  }, [currentStore]);
  useEffect(() => {
    if (schedule === 'openSchedule') {
      setMount(true);
    }
    if (schedule === 'closeSchedule') {
      var intervalId = setInterval(() => {
        setMount(false);
      }, 1000);

      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
    }
  }, [mount, schedule]);
  if (!mount) return null;
  var _addressStore = currentStore ? "".concat(currentStore.address, ",<br/> ").concat(currentStore.city, ", ").concat(currentStore.region, ", ").concat(currentStore.zipcode, ", ").concat(currentStore.country === 'CA' ? ' Canada' : '') : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.storeScheduleContainer, " ").concat(classes[schedule])
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.StoreScheduleHeader
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "storeSchedule.stockAvailability",
    defaultMessage: "Choose your preferred store to see product availability"
  }), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setSchedule('closeSchedule');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CloseIcon,
    height: 20,
    width: 20,
    alt: 'closeIcon'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.address
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.name
  }, currentStore ? currentStore.name : ''), /*#__PURE__*/React.createElement("div", {
    className: classes.add,
    dangerouslySetInnerHTML: {
      __html: _addressStore
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(currentStore && currentStore.phone),
    className: classes.phone
  }, currentStore ? currentStore.phone : ''), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      getDirectionGoogleMap({
        city: currentStore.city,
        country: currentStore.country,
        address: currentStore.address,
        region: currentStore.region,
        zipcode: currentStore.zipcode,
        lat: currentStore.latitude,
        lng: currentStore.longitude
      });
    },
    className: classes.directionButton
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "GetDirection",
    defaultMessage: "Get Direction"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: classes.redButton,
    onClick: () => {
      setSchedule('closeSchedule');
      history.push(currentStoreCode === "fr" ? "/magasin-localisateur" : "/store-locator");
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ChangeStore",
    defaultMessage: "Change Store"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.timeSchedule, " ").concat(classes[schedule])
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.timeHeader
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.storeHours",
    defaultMessage: "Store Hours"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.timeContainer
  }, timeSchedule.map((t, index) => /*#__PURE__*/React.createElement("div", {
    key: "".concat(t.day, "-").concat(index),
    className: classes.dailyContainer,
    style: t.today ? {
      fontWeight: 'bold'
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textTransform: 'capitalize'
    }
  }, formatMessage({
    defaultMessage: t.day,
    id: t.day
  })), /*#__PURE__*/React.createElement("div", null, t.time))))));
};
export default memo(StoreSchedule);